export default "__VITE_ASSET__0d70f4ba__"